import {
  FavoritablePayload,
  Home,
  LoginCredentials,
  LoginResponse,
  ProfileUpdatePayload,
  Res,
  User,
} from '@/types'

import base, { tagTypes } from './base'
import { panelApi } from './panel'

export const userApi = base.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginCredentials>({
      query: (body) => ({
        url: 'teachers/login',
        method: 'POST',
        body,
      }),
      transformResponse: (res: Res<LoginResponse>) => {
        const { data } = res
        const { user } = data
        const { profile } = user

        return {
          photo: profile?.photo,
          ...data,
        }
      },
      invalidatesTags: tagTypes,
    }),

    getUser: builder.query<User | null, void>({
      query: () => 'teachers/user',
      transformResponse: (res: Res<User>) => {
        const { data } = res
        const { profile } = data

        return {
          photo: profile?.photo,
          ...data,
        }
      },
      providesTags: ['User'],
    }),

    updateUser: builder.mutation<void, ProfileUpdatePayload | FormData>({
      query: (body) => ({
        url: 'profiles',
        method: 'POST',
        body,
      }),
      invalidatesTags: (_, error) => (!error ? ['User'] : []),
    }),

    home: builder.query<Home, void>({
      query: () => 'teachers/home',
      providesTags: ['Home'],
      transformResponse: (res: Res<Home>) => res.data,
    }),

    changeFavoritable: builder.mutation<{ message: string }, FavoritablePayload>({
      query: (body) => ({
        url: 'favoritables',
        method: 'POST',
        body,
      }),
      invalidatesTags: (_, error) => (!error ? ['TechTracks'] : []),
      async onQueryStarted({ favoritable_id }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          panelApi.util.updateQueryData('getTechTracks', undefined, (draft) => {
            const favoritable = draft.find((track) => track.id === favoritable_id)

            if (favoritable) {
              favoritable.favorited = !favoritable.favorited
            }
          }),
        )

        try {
          await queryFulfilled
        } catch {
          patchResult.undo()
        }
      },
    }),
  }),
})

export const validations = {
  coduser: { required: 'Preencha o seu código de usuário' },
  password: { required: 'Preencha o campo senha' },
}

export const {
  useGetUserQuery,
  useLoginMutation,
  useUpdateUserMutation,
  useHomeQuery,
  useLazyGetUserQuery,
  useChangeFavoritableMutation,
} = userApi
